export default __webpack_public_path__ + "static/media/newLeaf.7c875f79.png";